import React, {Component} from 'react';
import './Buttons.css';

export default class Buttons extends Component {
    constructor(props) {
        super(props);        
    }



    render() {
        return <div className="buttons">
            { this.props.values.map((d, i) => {
                return <button
                    className={"button" + (this.props.selected === d.value ? " selected" : "")}
                    onClick={() => {
                        this.props.callback(d.value);
                        this.setState({selected: i})}}>
                    {d.display}
                    </button>
            })}
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/Buttons/Buttons.jsx